import React, { useState } from "react";
import { NavWrap } from "./ShopForTyres";
import Close from "./../assets/cancel.svg";
import Download from "./../assets/white-download.svg";
import { useDispatch, useSelector } from "react-redux";
import { get_prods_excel, upload_excel } from "../actions/admin/Action";

const UploadInventory = () => {
  const uploadExcel = useSelector((state) => state?.admin?.upload_excel);
  const dispatch = useDispatch();
  const [file, setFile] = useState();
  return (
    <NavWrap>
      <div className="m2 claim-card p2 bulk-order">
        <span className="close">
          <img src={Close} alt="close" width={15} />
        </span>
        <h3>Upload Inventory - Select File</h3>
        <div className="d-flex">
          <div className="br-right pr2">
            <div className="d-flex mt2 sample-download">
              <button
                onClick={() => {
                  dispatch(
                    get_prods_excel({
                      email: localStorage.getItem("email"),
                    })
                  );
                }}
              >
                Sample download file
              </button>
              <span className="ml1">
                Note: Sample file are the plain template without the data
              </span>
            </div>
            <p>
              Download a sample .csv format or .xls format file and compare it
              to your import file to ensure that the file is ready to import.
            </p>
            <div className="mt2">
              <label className="label">
                Upload file <sup>*</sup>
              </label>
              <div className="upload-input">
                <input
                  id="file"
                  type={"file"}
                  onChange={(e) => {
                    setFile(e.target.files[0]);
                  }}
                  className="d-none"
                />
                <input className="" value={file?.name} />
                <button
                  onClick={() => {
                    document.getElementById("file").click();
                  }}
                >
                  <img
                    src={Download}
                    alt="download"
                    width={12}
                    className="mr1"
                  />
                  Choose file
                </button>
              </div>
              <span className="ml1 dim-note">
                Maximum File Size: 5 MB | File Format: CSV or TSV or XLS
              </span>
            </div>
            <div className="mt3">
              <button className="cancel-btn mr2">Cancel</button>
              <button
                className={`primary-btn ${
                  uploadExcel?.loading ? "loadBtn" : ""
                }`}
                onClick={() => {
                  dispatch(
                    upload_excel({
                      email: localStorage.getItem("email"),
                      token: localStorage.getItem("token"),
                      file,
                    })
                  );
                }}
              >
                Upload
              </button>
            </div>
          </div>
          <div className="m2 page-tips">
            <h3>Page tips</h3>
            <ul>
              <li>
                - Download the sample file by clicking on Sample File Button
              </li>
              <li>- Enter the order required details on the file.</li>
              <li>
                - If you have files in other formats, you can convert it to an
                accepted file format using any online/offline converter.
              </li>
              <li>- Upload the same file format.</li>
            </ul>
          </div>
        </div>
      </div>
    </NavWrap>
  );
};

export default UploadInventory;
